/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Provider } from '../../models/provider';

export interface GetProviders$Params {}

export function getProviders(
   http: HttpClient,
   rootUrl: string,
   params?: GetProviders$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Provider>> {
   const rb = new RequestBuilder(rootUrl, getProviders.PATH, 'get');
   if (params) {
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Provider>;
      })
   );
}

getProviders.PATH = '/api/weather/provider';
